import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { EvaluationIconStyled } from 'components/patterns/Icon/IconsStyled'
import { EvaluationBanner } from './LogicSetEvaluationBanner.styles'

const LogicSetEvaluationBanner = ({ evaluation }) => {
  return (
    <EvaluationBanner>
      <EvaluationIconStyled evaluation={evaluation} usePaletteStyles />
      {`${strings.evaluates_to} ${String(evaluation).toUpperCase()}`}
    </EvaluationBanner>
  )
}

LogicSetEvaluationBanner.propTypes = {
  evaluation: PropTypes.bool,
}

export default LogicSetEvaluationBanner
